import { useContext } from "react";
import { InversifyContext } from "./inversifyProvider.js";
function useContainer() {
  const { container } = useContext(InversifyContext);
  if (!container) {
    throw new Error("Inversify inversifyContainer isn't available");
  }
  return container;
}
function useService(identifier) {
  const container = useContainer();
  return identifier && container.isBound(identifier) ? container.get(identifier) : null;
}
function useServiceViaFactory(identifier, params) {
  const container = useContainer();
  const factory = container.get(identifier);
  return factory(params);
}
export {
  useService,
  useServiceViaFactory
};
//# sourceMappingURL=hooks.js.map
